export default "__VITE_ASSET__DmEJpN$t__"